export default __webpack_public_path__ + "static/media/ring_dark.db4c9549.png";